import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to top on every route change.
 * Mounted once at App root.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]);
  return null;
}
